export const TEMPLATE_MANIFEST = [
    {
        id: "lchika",
        name: "Lチカ(押しボタンLED点滅)",
        description: "照光式ボタンでLEDを点滅/消灯する最小サンプル。",
        tags: ["I/O", "入門"],
        tier: "free",
        loader: () => import("./lchika.json")
    },
    {
        id: "cylinder-reciprocate",
        name: "エアシリンダ往復",
        description: "片ソレノイド+ばね戻しのエアシリンダ往復制御サンプル。",
        tags: ["シリンダ", "I/O"],
        tier: "free",
        loader: () => import("./cylinder-reciprocate.json")
    },
    {
        id: "press-two-hand-counter",
        name: "両手起動プレス(カウンタパルス付)",
        description: "両手押しで片ソレシリンダーを下降させ、保持後に復帰してカウンタパルスを出すサンプル。",
        tags: ["プレス", "両手起動", "カウンタ"],
        tier: "free",
        loader: () => import("./press-two-hand-counter.json")
    },
    {
        id: "cylinder-phase-a-l1",
        name: "Phase A L1 シリンダ往復",
        description: "fa-agent Phase A L1 harness と一致する 2 ソレノイドの検証サンプル。",
        tags: ["シリンダ", "fa-agent", "L1"],
        tier: "free",
        loader: () => import("./cylinder-phase-a-l1.json")
    },
    {
        id: "pneumatic-valve-compat",
        name: "弁モデル互換サンプル",
        description: "旧 solenoidConfig と新 valveModel が混在する import/export 互換確認サンプル。",
        tags: ["シリンダ", "弁モデル", "互換"],
        tier: "free",
        loader: () => import("./pneumatic-valve-compat.json")
    }
];
